import { ReactiveState } from '../../../../utils/ReactiveState';

export type StripeData = {
  addressElementValue?: {
    name: string;
    firstName?: string;
    lastName?: string;
    address: {
      line1: string;
      line2: string | null;
      city: string;
      state: string;
      postal_code: string;
      country: string;
    };
    phone?: string;
  };
  stripeTokenId?: string;
};

const DEFAULT_STRIPE_DATA: StripeData = {};

export const state = {
  stripe: new ReactiveState<StripeData>(DEFAULT_STRIPE_DATA),
};
